import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const icons: AdminBlockTypeAttribute = {
  label: 'Show load more',
  key: 'loadMore',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default icons;
